<!-- <p>dashboard works!</p> -->
<link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css">
<h3 class="dashboard_question">Welcome {{name.split(" ")[0]}}</h3>

<h4 class="profile_header">Recent Orders</h4>
<div class="grid grid-cols-1 lg:grid-cols-2 gap-4 lg:gap-x-8 lg:gap-y-5">
	<ng-container *ngFor="let item of filteredOrderList">
		<fb-order-list-card [item]="item" class="fb-order-card"></fb-order-list-card>
	</ng-container>
</div>

<h4 class="profile_header">Cart</h4>
<div class="cart_cont">
	<ng-container *ngFor="let cart of cartList; let i = index">
		<ng-container *ngIf="i<3">
			<a [routerLink]="getProductLink(cart)"
			   target="_blank"
			   class="cart_cont_outer">
				<img
					src="{{cart.finishedProductPreview?
				cart.finishedProductPreview.product.heroImage:
				cart.fabricProductPreview!.product.heroImage}}"

					alt="{{cart.finishedProductPreview ?
					cart.finishedProductPreview.product.name :
					cart.fabricProductPreview!.product.name}}"/>

				<p class="name">
					{{cart.finishedProductPreview ?
					cart.finishedProductPreview.product.name :
					cart.fabricProductPreview!.product.name}}
				</p>
				<p class="unit">{{cart.quantity}} {{cart.unit}}</p>
			</a>
		</ng-container>
	</ng-container>

	<div class="cart_cont_outer for_more" *ngIf="cartList.length>0">
		<p (click)="openCart()">
			View Cart <span><i class="fa fa-caret"></i></span>
		</p>
	</div>


	<div class="empty_cart" *ngIf="cartList.length<1">
		Your cart is empty
	</div>
</div>

